import React from 'react';

import { Box, Inventory2Icon, Tooltip, makeStyles } from '@gogame/components';

import {
  DIMENSION_END_CARD,
  STATUS_MEDIA_ARCHIVED,
} from 'scenes/Trackers/Tracker/constants';
import {
  DIMENSION_CREATIVE,
  DIMENSION_CONCEPT,
} from 'scenes/Trackers/Tracker/constants';
import Image from './Image';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    position: 'relative',
  },
  bluredContainer: {
    filter: 'blur(1px)',
    position: 'absolute',
    overflow: 'hidden',
    borderRadius: '20%',
    width: '30px',
    height: '30px',
    zIndex: -1,
    top: '-5px',
    left: '-5px',
  },
  container: {
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    borderRadius: '20%',
    overflow: 'hidden',
    flexShrink: 0,
    position: 'relative',
    border: ({ hasEndCard }) =>
      `1px solid ${hasEndCard ? 'white' : 'transparent'}`,
    boxShadow: ({ hasEndCard }) => (hasEndCard ? theme.shadows[0] : null),
  },
  styledOverlay: {
    background: theme.palette.action.disabled,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  icon: {
    color: 'white',
    fontSize: '14px',
    margin: 'auto',
  },
  iconContainer: {
    borderRadius: '50%',
    background: theme.palette.disabled,
    width: '22px',
    height: '22px',
    display: 'flex',
  },
  img: {
    position: 'relative',
    zIndex: 1,
  },
}));

const Media = ({ rowData, type, onOpenConcept, onOpenCreative }) => {
  const classes = useStyles({ hasEndCard: rowData?.hasEndCard });

  const handleClick = () => {
    if (type === DIMENSION_CONCEPT) {
      onOpenConcept(Number(rowData.Dimension.id));
    }
    if (type === DIMENSION_CREATIVE || type === DIMENSION_END_CARD) {
      onOpenCreative(Number(rowData.Dimension.id));
    }
  };

  const content = (
    <Box className={classes.mainContainer}>
      {rowData.hasEndCard && (
        <Box className={classes.bluredContainer}>
          <Image
            className={classes.img}
            imageUrl={rowData.media.thumbnailUrl}
            fullImageUrl={rowData.media.thumbnailUrl}
          />
        </Box>
      )}
      <Box className={classes.container}>
        <Image
          imageUrl={rowData.media.thumbnailUrl}
          fullImageUrl={rowData.media.thumbnailUrl}
          className={classes.img}
          onClick={handleClick}
        />
        {rowData.media?.status === STATUS_MEDIA_ARCHIVED ? (
          <Box className={classes.styledOverlay} onClick={handleClick}>
            <Box className={classes.iconContainer}>
              <Inventory2Icon
                className={classes.icon}
                size={'xs'}
              ></Inventory2Icon>
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
  return rowData?.hasEndCard ? (
    <Tooltip
      title={'Running with an end card'}
      wrapper
      wrapperComponent={'div'}
    >
      {content}
    </Tooltip>
  ) : (
    <>{content}</>
  );
};
export default Media;
